export default __webpack_public_path__ + "static/media/CaseStudies3.cc132238.png";